import * as React from "react";
import { connect } from "react-redux";

import {resetOriginalPwd} from "./action";

import ResetPwd from "../../screens/ResetPwd";

class ResetPwdContainer extends React.Component<Props, State> {
  render() {
    return <ResetPwd 
    resetOriginalPwd={this.props.resetOriginalPwd}
    />;
  }
}
function bindAction(dispatch) {
  return {
    resetOriginalPwd: (val) => {
        dispatch(resetOriginalPwd(val));
      },
  };
}
const mapStateToProps = (state) => {
  return {
  };
};

export default connect(mapStateToProps, bindAction)(ResetPwdContainer);
